module.exports = __webpack_public_path__ + "img/2.2潭拓寺帝树王（杨树田-摄).52c0d4db.jpg";